import axios, { AxiosResponse } from "axios";
import { VatNumberResponse } from "types/integrations";

export const getVatNumber = async () => {
  const response: AxiosResponse<VatNumberResponse> = await axios.get(
    "/tenant/qtahseel/get_vat_number",
  );
  return response.data;
};
